import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

/**
 * Atomically save brand slug via Admin SDK callable.
 * @param {{ brandId: string, slug: string }} payload
 */
const saveBrandSlug = async ({ brandId, slug }) => {
  try {
    const callable = functions.httpsCallable('saveBrandSlug')
    const result = await callable({ brandId, slug })
    return {
      ok: true,
      data: result.data,
    }
  } catch (error) {
    console.error('[saveBrandSlug] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default saveBrandSlug
